export enum TransactionStatus {
    SUCCESS,
    ERROR,
}
